export const styles = {
  action: {
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    '&:hover': {
      cursor: 'pointer',
    },
  },
  actionRevoke: {
    color: '#FB0000',
  },
  actionCreate: {
    color: '#04B115',
  },
}
